// extracted by css-extract-rspack-plugin
export default {"container":"_8ceed2ce"};